import type { ReactNode } from 'react'
import { PageHead } from '@w7/ui'

export function CmPanel({
  title,
  subtitle,
  actions,
  wide,
  children,
}: {
  title: string
  subtitle?: string
  actions?: ReactNode
  /** Full-width catalog layout — sections stack without one cramped card. */
  wide?: boolean
  children: ReactNode
}) {
  return (
    <div className={`cm-page${wide ? ' cm-page-wide' : ''}`}>
      <PageHead title={title} subtitle={subtitle} actions={actions} />
      <div className={wide ? 'cm-catalog-stack' : 'cm-panel'}>{children}</div>
    </div>
  )
}

/** Operator-facing status line — never dump raw API JSON. */
export function CmStatus({ value, label = 'Status' }: { value: string; label?: string }) {
  if (!value) return null
  return (
    <div className="cm-status" aria-label={label}>
      <div className="cm-status-head">{label}</div>
      <p className="cm-status-body">{value}</p>
    </div>
  )
}

/** @deprecated Prefer CmStatus — kept for any leftover imports. */
export function CmResult({ value, label = 'Result' }: { value: string; label?: string }) {
  return <CmStatus value={value} label={label} />
}

export const SPORTS = [
  { value: 'soccer', label: 'Soccer' },
  { value: 'tennis', label: 'Tennis' },
  { value: 'cricket', label: 'Cricket' },
] as const
